import type { TranslationMessages } from '../types';

export const auth: TranslationMessages = {
  change_password: 'Change Password',
  logout: 'Logout',
  forgot_password: 'Forgot password?',
  remember_password: 'Remember password',
  reset_password: 'Reset password',
  email: 'Email',
  username_email_password_required: 'Username/email and password are required',
  invalid_credentials: 'Invalid username/email or password',
  invalid_username_email: 'Invalid username/email',
  invalid_password: 'Invalid password',
  invalid_username: 'Invalid username',
  invalid_email: 'Invalid email',
  invalid_username_or_email: 'Invalid username/email',
  close_window: 'Close',
  set_new_password: 'Update Password',
  username_or_email: 'Username/email',
  username_or_email_placeholder: 'Enter username or email',
  password: 'Password',
  password_placeholder: 'Enter your password',
  sign_in: 'Sign In',
  welcome_back: 'Welcome back! Please sign in to your account.',
  or: 'or',
  sign_in_with_passkey: 'Sign in with Passkey',
  passkey_error: 'Failed to sign in with passkey',
  passkey_not_supported: 'Passkey is not supported on this device',
  no_passkeys:
    'No passkeys registered. Please sign in with username/password first, then register a passkey in your profile settings.',
  passkey_register: 'Register Passkey',
  passkey_register_success: 'Passkey registered successfully',
  passkey_register_error: 'Failed to register passkey',
  passkey_not_registered:
    'No passkeys registered yet. Please log in with your username/password first, then register a passkey in your profile settings.',
  register_passkey: 'Register Passkey',
  register_passkey_description:
    'Would you like to set up a passkey for faster and more secure login? You can use your fingerprint, face recognition, or device PIN.',
  register_passkey_button: 'Register Passkey',
  register_passkey_error: 'Failed to register passkey',
  register_passkey_success: 'Passkey registered successfully',
  register_passkey_ios_guidance:
    'iOS Device Detected: Make sure you have Face ID, Touch ID, or a device passcode set up. When prompted, complete the biometric authentication to register your passkey.',
  passkey_ios_cancelled:
    'Passkey registration was cancelled. Please try again and ensure you complete the biometric authentication.',
  passkey_ios_security_error:
    'Security error during passkey registration. Please ensure you are using HTTPS and try again.',
  passkey_ios_invalid_state:
    'Passkey already exists for this account. Please try logging in with your passkey instead.',
  passkey_ios_not_supported:
    'Passkey registration was cancelled or not supported on this device. Please ensure you have Face ID, Touch ID, or a device passcode set up.',
  password_changed_successfully: 'Password changed successfully',
  current_password_incorrect: 'Current password is incorrect',
  new_password_required: 'All fields are required',
  new_passwords_do_not_match: 'New passwords do not match',
  new_password_min_length: 'New password must be at least 8 characters long',
  current_password: 'Current Password',
  new_password: 'New Password',
  confirm_new_password: 'Confirm New Password',
  not_authenticated: 'Not authenticated',
  change_password_description:
    'Enter your current password and choose a new password',
  qr_login: {
    switch_user: 'Switch User',
    description:
      'Scan the QR code with your mobile device to log in. Share the verification code when prompted.',
    generating: 'Generating QR code...',
    verification_code: 'Verification Code',
    code_help: 'Share this code when confirming on your mobile device',
    expires_in: 'Expires in',
    expired: 'QR code has expired',
    waiting_confirmation: 'Waiting for confirmation...',
    session_expired: 'Session expired',
    already_used: 'Already used',
    refresh: 'Refresh',
    code_copied: 'Code copied!',
    success: 'Logged in successfully!',
    logging_in: 'Logging in...',
    confirm_login: 'Confirm Login',
    confirm_description:
      'Please confirm that you want to log in on the other device. The verification code has been auto-filled for you.',
    logging_in_as: 'Logging in as',
    code_instructions:
      'Enter the 6-character verification code shown on the other device',
    confirmed: 'Confirmed!',
    redirecting: 'Redirecting...',
    not_logged_in: 'Not logged in',
    must_login_first:
      'You must be logged in on this device to confirm login on another device.',
    confirming: 'Confirming...',
    confirmation_success: 'Login confirmed successfully!',
    confirmation_failed: 'Confirmation failed',
    confirmation_error: 'An error occurred during confirmation',
    invalid_session: 'Invalid session ID',
    invalid_code_format: 'Please enter a valid 6-character verification code',
    must_be_logged_in: 'You must be logged in on your mobile device to confirm',
  },
  recent_users: 'Recent Users',
};
